import React, { Fragment, useEffect } from 'react'
import { Link as LinkTo, useParams, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  CardHeader,
  Avatar,
  CardContent,
  CardActions,
  Typography,
  Link,
  IconButton,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import FileCopyIcon from '@material-ui/icons/FileCopy'

import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { deleteLink, getLinkById } from '../../store/actions/links/links'
import { Loader } from './../Loader/Loader'
import { useStyles } from './styles'
import { useToken } from './../../hooks/useToken'
import { setAlert } from '../../store/actions/alert/setAlert'

export const DetailPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const linkId = useParams().id
  const headers = useToken()
  const isLoading = useSelector((state) => state.loader.isLoading)
  const link = useSelector((state) => state.links.link)

  const copyToClipboard = (data) => {
    navigator.clipboard.writeText(data)
    dispatch(setAlert(true, 'success', `Link ${data} copied`, 2000))
  }

  const deleteHandler = () => {
    dispatch(deleteLink(linkId))
    history.push('/')
  }

  useEffect(() => {
    dispatch(getLinkById(linkId, headers))
  }, [dispatch]) //eslint-disable-line
  if (isLoading) {
    return <Loader />
  }
  if (Object.keys(link).length === 0) {
    return null
  }
  return (
    <Fragment>
      <Card elevation={0} className={classes.card}>
        <CardHeader
          avatar={
            <IconButton
              className={classes.iconButton}
              component={LinkTo}
              to='/'
              aria-label='back'
            >
              <Avatar className={classes.avatar}>
                <ArrowBackIcon />
              </Avatar>
            </IconButton>
          }
          title={
            <Typography variant='h5' color='primary'>
              Detail information about link
            </Typography>
          }
        />
        <CardContent>
          <Typography variant='body1' gutterBottom paragraph>
            <strong>Link id:</strong>&nbsp;{link._id}
          </Typography>
          <Typography variant='body1' gutterBottom paragraph>
            <strong>Original link:</strong>&nbsp;
            <Link
              href={link.originLink}
              target='_blank'
              rel='noopener noreferrer'
            >
              {`${link.originLink}`}
            </Link>
          </Typography>
          <Typography variant='body1' gutterBottom paragraph>
            <strong>Short link:</strong>&nbsp;
            <Link
              href={link.generatedLink}
              target='_blank'
              rel='noopener noreferrer'
            >
              {`${link.generatedLink}`}
            </Link>
          </Typography>
          <Typography variant='body1' gutterBottom paragraph>
            <strong>Number of clicks:</strong>&nbsp;{link.clicks}
          </Typography>
          <Typography variant='body1'>
            <strong>Creation date:</strong>&nbsp;
            {new Date(link.date).toLocaleString()}
          </Typography>
        </CardContent>
        <CardActions disableSpacing>
          <IconButton
            color='primary'
            aria-label='copy link'
            onClick={() => copyToClipboard(link.generatedLink)}
          >
            <FileCopyIcon />
          </IconButton>
          <IconButton
            className={classes.delete}
            aria-label='delete'
            onClick={deleteHandler}
          >
            <DeleteIcon />
          </IconButton>
        </CardActions>
      </Card>
    </Fragment>
  )
}
